(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7702],{

/***/ 72201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* reexport */ FaqAccordionItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-accessible-accordion/dist/es/index.js
var es = __webpack_require__(11876);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./node_modules/react-markdown/src/react-markdown.js
var react_markdown = __webpack_require__(38456);
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);
;// CONCATENATED MODULE: ./components/atomic/FaqAccordionItem/FaqAccordionItem.js






var FaqAccordionItem = function(param) {
    var item = param.item, isRequested = param.isRequested;
    var accordionItemRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if ( true && isRequested) {
            setTimeout(function() {
                window.scrollTo(0, accordionItemRef.current.offsetTop);
            }, 400);
        }
    }, [
        isRequested
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
        triggerOnce: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: accordionItemRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                uuid: item.slug,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemButton */.on, {
                            children: item.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemPanel */.Mt, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                            children: item.body
                        })
                    })
                ]
            })
        })
    });
};
FaqAccordionItem.propTypes = {
    item: (prop_types_default()).object.isRequired,
    isRequested: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./components/atomic/FaqAccordionItem/index.ts



/***/ }),

/***/ 47702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Faqs_Faqs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-accessible-accordion/dist/es/index.js
var es = __webpack_require__(11876);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./node_modules/remove-markdown/index.js
var remove_markdown = __webpack_require__(26525);
var remove_markdown_default = /*#__PURE__*/__webpack_require__.n(remove_markdown);
// EXTERNAL MODULE: ./components/views/HomePage/Faqs/faqs.module.scss
var faqs_module = __webpack_require__(44737);
var faqs_module_default = /*#__PURE__*/__webpack_require__.n(faqs_module);
// EXTERNAL MODULE: ./components/atomic/FaqAccordionItem/index.ts + 1 modules
var FaqAccordionItem = __webpack_require__(72201);
;// CONCATENATED MODULE: ./components/views/HomePage/Faqs/Faqs.js








var Faqs = function(param) {
    var faqList = param.faqList;
    var ref = (0,react.useState)([]), activeFaqs = ref[0], setActiveFaqs = ref[1];
    var ref1 = (0,react.useState)((faqList === null || faqList === void 0 ? void 0 : faqList.items.length) > 0 ? faqList.items[0].content.items : []), faqs = ref1[0], setFaqs = ref1[1];
    (0,react.useEffect)(function() {
        if ((faqList === null || faqList === void 0 ? void 0 : faqList.items.length) > 0) {
            setFaqs(faqList.items[0].content.items);
        }
    }, [
        faqList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (faqs_module_default()).faqs,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    children: '\n            {\n              "@context": "https://schema.org",\n              "@type": "FAQPage",\n              "mainEntity": ['.concat(faqs.map(function(faq) {
                        return JSON.stringify({
                            "@type": "Question",
                            name: "".concat(faq.title),
                            acceptedAnswer: {
                                "@type": "Answer",
                                text: "".concat(remove_markdown_default()(faq.body))
                            }
                        });
                    }), "]\n            }\n          ")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (faqs_module_default()).grid,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                    triggerOnce: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Accordion */.UQ, {
                        allowZeroExpanded: true,
                        preExpanded: activeFaqs,
                        onChange: function(value) {
                            return setActiveFaqs(value);
                        },
                        children: faqs.length > 0 && faqs.map(function(faq) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqAccordionItem/* FaqAccordionItem */.Q, {
                                item: faq,
                                isActive: activeFaqs.includes(faq.slug)
                            }, faq.slug);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Faqs_Faqs = (Faqs);

;// CONCATENATED MODULE: ./components/views/HomePage/Faqs/index.js



/***/ }),

/***/ 44737:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faqs":"faqs_faqs__HZIAb","grid":"faqs_grid__CiYBK","phAnimation":"faqs_phAnimation__mClEt"};

/***/ })

}]);